<template>
    <prime-dialog
        :visible="props.visible"
        class="konami-easter-egg-dialog"
        dismissable-mask
        modal
        :draggable="false"
        :style="{ width: 'min(96vw, 480px)' }"
        header="&#9889; You found a Spark!"
        @update:visible="emit('update:visible', $event)"
    >
        <div class="konami-easter-egg-content">
            <p>The grid needs defending…</p>
            <game-selector />
        </div>
    </prime-dialog>
</template>

<script setup lang="ts">
import PrimeDialog from 'primevue/dialog';
import GameSelector from '@/components/layout/GameSelector.vue';

const props = defineProps<{
    visible: boolean;
}>();

const emit = defineEmits<{
    'update:visible': [value: boolean];
}>();
</script>

<style scoped lang="scss">
.konami-easter-egg-dialog {
    .p-dialog-content {
        padding: var(--extraLargeSpacing);
    }

    .konami-easter-egg-content {
        display: flex;
        flex-direction: column;
        gap: var(--defaultSpacing);
    }
}
</style>
